import { FC } from 'react';
import { Card } from '@belong/ui-components/components/forms';
import { RichText } from '@belong/ui-components/components/styles/Typography';
import { Stack } from '@belong/ui-components/components/ui';
import SectionInfo from '@belong/ui-sections/sections/sectionInfo/view';
import { AUTHENTICATION_FORM_TEST_ID } from '../../../constants';
import { ContactUsWrapper } from '../ResetPassword.styles';
import { IStatusScreenContent } from '../types';

interface IStatusScreenProps extends IStatusScreenContent {
  testIdSuffix: string;
  email: string;
  dateOfBirth: string;
}

export const StatusScreen: FC<IStatusScreenProps> = ({
  sectionInfoConfirmation,
  contactUsInfo,
  testIdSuffix,
  email,
  dateOfBirth
}) => {
  return (
    <Card data-testid={`${AUTHENTICATION_FORM_TEST_ID.PASSWORD_RESET_LINK}-${testIdSuffix}`} hasSectionPaddingTop>
      <Stack space={{ xs: 'large', md: 'xlarge' }}>
        <SectionInfo
          imageSize="small"
          headingPosition="top"
          dictionary={{ email, dateOfBirth }}
          {...sectionInfoConfirmation}
          autoFocusHeading
        />
        <ContactUsWrapper>
          <RichText h3="headingSmall" alignment="center" {...contactUsInfo} />
        </ContactUsWrapper>
      </Stack>
    </Card>
  );
};
